import { AxiosInstance } from 'axios';
import { CommunityNote } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'community-note';

export class CommunityNoteApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async getCommunityNotes(): Promise<Array<CommunityNote>> {
    await simulate();
    const response = await this.apiInstance.get(`/`);

    return response.data; 
  }
}
